import React, { Component } from "react";
import { Modal, Button } from "antd";
import {Player} from "@lottiefiles/react-lottie-player";

class ModalDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false
        };
    }

    render() {
        const { confirmLoading } = this.state;
        const { toggleShowModal, showModal, caption } = this.props;
        return (
            <Modal
                title="Information"
                visible={showModal}
                confirmLoading={confirmLoading}
                okText={"Close"}
                onOk={() => toggleShowModal(false)}
                onCancel={() => toggleShowModal(false)}
                footer={[
                    <div style={{textAlign: "center"}}>
                        <Button key="back" type="primary" onClick={() => toggleShowModal(false)}>
                            Close
                        </Button>
                    </div>
                ]}
                width={500}>
                <Player
                    src='https://lottie.host/302476c6-4fe9-442c-91d6-858212a3fab2/Hv3Uom2AVx.json'
                    className="player"
                    loop
                    autoplay
                    style={{width: "30%"}}
                />
                <h3 style={{textAlign: "center"}}>{caption ? caption : "SPK Request Validated"}</h3>
            </Modal>
        );
    }
}

export default ModalDialog;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalDialog.js